import { useMemo } from "react";

export const calc_slider_pct = (val: number, min: number, max: number) => {
  if (val < min) {return 0;}
  if (val > max) {return 100;}
  return (val - min) / (max - min) * 100;
};

export const useSliderPercentages = (
  desired_advance: string,
  tenure: string,
  loan_calc_constants: {
    min_loan_value: number;
    max_loan_value: number;
    loan_tenures_min: number;
    loan_tenures_max: number;
  }
) => {
  const desired_advance_pct = useMemo(() => {
    return calc_slider_pct(
      Number(desired_advance),
      loan_calc_constants.min_loan_value,
      loan_calc_constants.max_loan_value
    );
  }, [desired_advance, loan_calc_constants]);

  const tenure_pct = useMemo(() => {
    return calc_slider_pct(
      Number(tenure),
      loan_calc_constants.loan_tenures_min,
      loan_calc_constants.loan_tenures_max
    );
  }, [tenure, loan_calc_constants]);

  return { desired_advance_pct, tenure_pct };
};
